exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.expand[data-v-025cfd1f] {\n  height: 25px !important;\n}\n@media only screen and (max-width: 768px) {\n.expand[data-v-025cfd1f] {\n    height: 55px !important;\n}\n.ss[data-v-025cfd1f] {\n    flex: 0 0 30%;\n    max-width: 30%;\n}\n.s1[data-v-025cfd1f] {\n    flex: 0 0 70%;\n    max-width: 70%;\n}\n.o3[data-v-025cfd1f] {\n    order: 1;\n}\n.o4[data-v-025cfd1f] {\n    order: 2;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-025cfd1f","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/components/reports/errorlogreport/errorlogreport.component.scss
// module id = 1762
// module chunks = 0